{
  "feedback-internal-details-page": {
    "buttons": {
      "submit": "SUBMIT"
    },
    "text": {
      "comment": "Your comment",
      "cleanliness": "Ambience and cleanliness",
      "hint": "Please help us know how you feel about our service",
      "service": "Service",
      "staff": "Staff"
    }
  }
}
